<template>
  <v-content class>
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />
    <v-container
      v-if="proposal"
      fluid
      grid-list-xl
      id
      class="white-background proposta-header"
    >
      <v-layout row wrap>
        <v-flex xs12>
          <a
            href
            class="back-button"
            @click.prevent="$router.push({ path: '/mesa-de-trabalho' })"
          >
            <svg-icon>ArrowBack</svg-icon>
            <span>Voltar para Mesa</span>
          </a>
        </v-flex>

        <v-flex class="md6 sm12">
          <p class="secondary--text subheading text-uppercase mb-0">
            {{ policyDate }}
          </p>
          <h1 class="proposta-title darkblue--text d-inline-block">
            Nº {{ proposal.id_apolice }}
          </h1>
        </v-flex>

        <v-flex offset-md3 class="md3 sm12" text-xs-right>
          <drop-down
            :items="endorsementOptions"
            @menu-click="endorsementAction"
          >
            <template v-slot:title>
              <span>Criar Endosso</span>
              <v-icon class="ml-2">add_circle_outline</v-icon>
            </template>
          </drop-down>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="proposal" fluid grid-list-md id class>
      <v-layout row wrap class="proposta-content">
        <v-flex xs12>
          <v-expansion-panel v-model="panel" class="document-stack">
            <v-expansion-panel-content
              v-for="(endorsement, i) in endorsements"
              :key="i"
            >
              <template v-slot:header>
                <div
                  class="pr-2 py-2"
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div>
                    <h6
                      class="d-block secondary--text body-2 text-uppercase mb-1"
                    >
                      Endosso
                    </h6>
                    <p class="title darkblue--text font-weight-bold mb-0">
                      Nº {{ endorsement.nr_endosso }}
                    </p>
                  </div>
                  <p class="secondary--text subheading text-uppercase mb-0">
                    {{ endorsementDate(endorsement) }}
                  </p>
                </div>
              </template>

              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn
                  class="button jns-button yellow-button flex md3"
                  @click="getDocumentoEndosso(endorsement.id_endosso)"
                >
                  <i class="mr-2 ml-0">save_alt</i>
                  <span>Documento</span>
                </v-btn>
                <v-btn
                  v-if="endorsement.status === 'INSERIR'"
                  class="button jns-button yellow-button flex md3"
                  @click="getBoletoEndosso(endorsement.id_endosso)"
                >
                  <i class="mr-2 ml-0">save_alt</i>
                  <span>Boleto</span>
                </v-btn>
              </v-layout>
              <document-tabs
                :current="tabIndex"
                :items="getEndorsementTabTexts(endorsement)"
                @change-tab="changeTab"
              />

              <document-information
                :acompanhamento="corretorAnalise"
                :proposal="endorsement"
                is-endorsement
                :tab-index="tabIndex"
                @reanalysis="setTabReanalise"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>

      <v-footer
        class="proposta__footer"
        v-if="
          !statusWhichDenyToGiveUpProposal.includes(proposal.status) &&
            tabIndex == 'Timeline' &&
            corretorAnalise
        "
      >
        <v-flex class="xs6">
          <v-btn class="jns-button white-button width-auto" @click="desistir()"
            >Desistir</v-btn
          >
        </v-flex>
        <v-flex class="xs6 pull-right">
          <v-btn
            class="jns-button yellow-button width-auto"
            @click="dialogQuestionamento = true"
            >Questionamento</v-btn
          >
        </v-flex>
      </v-footer>

      <!-- Modal Questionamento -->
      <questionamento-component
        :questionamentoDialog="dialogQuestionamento"
        :questionamentoSucessoDialog="questionamentoSucessoModal"
        @send="sendQuestionamento"
        @close="dialogQuestionamento = false"
      />

      <v-dialog
        v-model="showEndossoCancelamentoDialog"
        persistent
        :max-width="'1000'"
      >
        <base-modal>
          <endosso-cancelamento-component
            v-if="showEndossoCancelamentoDialog"
            :proposta="proposal"
            @fechar="showEndossoCancelamentoDialog = false"
          />
        </base-modal>
      </v-dialog>

      <v-dialog
        v-model="showEndossoCancelamentoManualDialog"
        max-width="auto"
        max-height="680"
      >
        <base-modal>
          <template
            v-if="params && params.conteudo && params.conteudo.url_formulario"
          >
            <iframe
              :src="params.conteudo.url_formulario"
              width="100%"
              height="610"
              frameborder="0"
            ></iframe>

            <v-layout row wrap>
              <v-flex offset-md10 md2 offset-sm6 sm6 pb-0>
                <button
                  class="button jns-button yellow-button"
                  @click="showEndossoCancelamentoManualDialog = false"
                >
                  Fechar
                </button>
              </v-flex>
            </v-layout>
          </template>

          <h2
            v-else
            class="title"
            v-html="'Não foi possível carregar o formulário'"
          ></h2>
        </base-modal>
      </v-dialog>

      <v-dialog v-model="errorModal" :max-width="'640'">
        <base-modal>
          <h2 class="title" v-html="error.title"></h2>
          <p class="description" v-html="error.message"></p>
          <v-layout row wrap>
            <v-flex xs4 offset-xs8>
              <button
                class="button jns-button yellow-button"
                @click="errorModal = false"
              >
                OK
              </button>
            </v-flex>
          </v-layout>
        </base-modal>
      </v-dialog>

      <v-dialog v-model="modalDesistir" :max-width="'640'">
        <base-modal>
          <h2 class="title">Informe o motivo da desistência</h2>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                class="form-select-box"
                label="Motivo"
                v-model="id_motivo"
                placeholder="Motivo "
                :rules="[(v) => !!v || 'Este campo deve ser preenchido!']"
                :items="motivos"
                :item-value="'id'"
                :item-text="'descricao'"
              ></v-select>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                label="Observações"
                v-model="observacao"
                class="input-group"
                outline
              ></v-textarea>
            </v-flex>

            <v-flex xs6>
              <v-btn
                class="button jns-button yellow-button"
                @click="quitProposal()"
                >OK</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                class="button jns-button yellow-button"
                @click="modalDesistir = false"
                >Cancelar</v-btn
              >
            </v-flex>
          </v-layout>
        </base-modal>
      </v-dialog>

      <v-dialog v-model="showPendenciesModal" :max-width="640">
        <base-modal>
          <v-layout row wrap class="mb-2">
            <h2 class="header ml-3 mb-2">Irregularidades do tomador</h2>
            <process-list-item
              v-for="(value, key) in validacoes"
              :key="`validacoes_${key}`"
              :process="{
                text: validacoesLabel[key],
                status: value ? 'DONE' : 'ERRO',
              }"
            />
          </v-layout>
        </base-modal>
      </v-dialog>

      <v-dialog
        v-model="endorsementPermissionProblemsModal"
        width="700"
        content-class="endorsementPermissionProblems"
      >
        <problemas-permissao-endosso-modal
          v-if="endorsementPermissionProblemsModal"
          :validacoes="proposal.validacoes"
        />
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script type="js">
import _ from "lodash";
import moment from "moment";
import ViewMixin from "@/mixins/ViewMixin";
import { endorsementOptions, canEndorse, downloadEndorsementOptions } from "@/libs/endorsement"
import PropostaMixin, {
  STATUS_QUESTIONAMENTO_VALIDOS
} from "@/mixins/PropostaMixin";
import DocumentInformation from "@/components/DocumentInformation.vue";
import { mapActions } from "vuex";
import ProcessListItem from "@/components/Apolice/Steps/ProcessListItem.vue";


const validacoesLabel = {
  corretor_lider: "Corretor líder",
  proposta_emitida: "Proposta emitida",
  proposta_vigente: "Proposta vigente",
  segurado_nao_blacklist: "Segurado com situação cadastral irregular",
  tomador_ccg_formalizado: "Tomador CCG formalizado",
  apolice_sem_cossegurado: "Apólice com cossegurado",
  tomador_nao_blacklist: "Tomador com situação cadastral irregular"
};

export default {
  name: "DetalhesApolice",
  mixins: [ViewMixin, PropostaMixin],
  components: { DocumentInformation, ProcessListItem },
  data: () => ({
    validacoesLabel,
    endorsementOptions,
    downloadEndorsementOptions,
    policy: null,
    endorsements: null,
    params: {},
    endorsementPermissionProblemsModal: false,
    showPendenciesModal: false,
    showEndossoCancelamentoManualDialog: false,
    showEndossoCancelamentoDialog: false,
    statusWhichAllowToEditProposal: ["CORRETOR_ANALISE_EMISSAO"],
    statusWhichAllowToPrintMinuta: [
      "SEGURADORA_ANALISE_EMISSAO",
      "CORRETOR_ANALISE_EMISSAO",
    ],
    statusWhichDenyToGiveUpProposal: ["EMITIDA", "CANCELADA", "RECUSADA"],
    tabTexts: ["Timeline", "Informações da Proposta", "Histórico Geral"],
    motivos: [],
    documentosData: [],
    modalidades: [
      { text: "Modalidade 1" },
      { text: "Modalidade 2" },
      { text: "Modalidade 3" },
    ],
    questionamento: {
      body: {
        observacoes: "",
        documentos: [],
      },
    },
    error: {
      title: "",
      message: "",
    },
    proposal: false,
    timeline: false,
    dialogQuestionamento: false,
    corretorAnalise: false,
    modalDesistir: false,
    errorModal: false,
    questionamentoSucessoModal: false,
    observacao: "",
    tabIndex: "Timeline",
    EMITIDA_STATUS: "EMITIDA",
    id_motivo: 0,
    panel: 0,
  }),
  mounted() {
    this.init();
  },
  computed: {
    policyDate() {
      if (!this.proposal) {
        return "---";
      }
      return moment(this.proposal.data_emissao).format("L");
    },
    validacoes() {
      return this.proposal?.validacoes || {};
    }
  },
  methods: {
    ...mapActions([
      "GET_MINUTA",
      "GET_BOLETO",
      "GET_POLICY",
      "QUIT_PROPOSAL",
      "POST_QUESTIONAMENTO",
      "GET_MINUTA_ENDOSSO",
      "GET_BOLETO_ENDOSSO",
    ]),

    endorsementDate({ inicio_vigencia }) {
      return moment(inicio_vigencia).format("L");
    },

    endorsementAction(kind) {
      if (canEndorse(this.proposal, kind)) {
        this[this.endorsementOptions[kind].action]()
      } else {
        this.showEndorsementPermissionProblems(this.proposal);
      }
    },

    showEndorsementPermissionProblems(data) {
      this.selectedPolicyForEndorsement = data;
      this.endorsementPermissionProblemsModal = true;
    },

    setShowEndossoCancelamentoDialog() {
      this.showEndossoCancelamentoDialog = true;
    },

    goToForm(endorsement) {
      const { apoliceId } = this.$route.params;
      const canEndorsePolicy = canEndorse(this.proposal);
      this.showPendenciesModal = !canEndorsePolicy;
      canEndorsePolicy && this.$router.push({
        name: "Solicitação de Endosso",
        params: {
          apoliceId,
          endorsement
        }
      });
    },

    async init () {
      try {
        const { apoliceId } = this.$route.params;
        this.showLoadingIndicator();
        const policy = await this.GET_POLICY({ apoliceId });
        const { endossos, validacoes, ...policyInfo } = policy;
        this.propostaId = policy.id;
        this.produtoId = policy.id_produto;
        this.proposal = policy;
        this.endorsements = endossos.map(
          endosso => ({
            ..._.omit(policyInfo, "status"),
            ...endosso
          })
        );
        this.deveMostrarQuestionamento();
        this.setActiveTab();
      } catch (error) {
        console.error(error);
      } finally {
        this.hideLoadingIndicator();
      }
    },

    changeTab($event) {
      this.tabIndex = $event.currentTarget.value;
    },

    editProposal() {
      const { propostaId, produtoId } = this.$route.params;
      this.$router.push({
        path: `/proposta/editar/${propostaId}/${produtoId}`,
      });
    },

    setTabReanalise(endorsement) {
      const { status } = endorsement;
      if (status === "GERAR") {
        this.goToEndorsementSecondStep(endorsement);
      } else {
        this.tabIndex = this.getProposalStatusText(status);
      }
    },

    deveMostrarQuestionamento() {
      const { status } = this.proposal;
      this.corretorAnalise =
        STATUS_QUESTIONAMENTO_VALIDOS.indexOf(status) >= 0;
    },

    setActionOpcaoBotao(action) {
      this[action]();
    },

    setActiveTab() {
      if (
        location.href.lastIndexOf("credito") > 0 &&
        this.tabTexts.filter((tab) => tab == "Formulário de Crédito").length > 0
      )
        this.tabIndex = "Formulário de Crédito";
      else if (
        location.href.lastIndexOf("subscricao") > 0 &&
        this.tabTexts.filter((tab) => tab == "Analise de Subscrição").length > 0
      )
        this.tabIndex = "Analise de Subscrição";
      else if (
        location.href.lastIndexOf("resseguro") > 0 &&
        this.tabTexts.filter((tab) => tab == "Analise de Resseguro").length > 0
      )
        this.tabIndex = "Analise de Resseguro";
    },

    getEndorsementTabTexts(endorsement) {
      const text = this.getProposalStatusText(endorsement.status);
      return text && [...this.tabTexts, text] || this.tabTexts;
    },

    goToEndorsementSecondStep(endorsement) {
      this.goToForm(endorsement);
    },
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .header_acoes {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .proposta-content-title {
    color: #4e4e4e;
    font-size: 18px;
    font-weight: bold;
  }
  .container-form {
    margin: 0;
    padding: 0;
    .white-background {
      margin: 0;
    }
  }
  .form-title {
    position: relative;
    h1 {
      padding: 10px;
      font-size: 22px;
      font-weight: bold;
      color: #4e4e4e;
      text-align: center;
    }
    i {
      position: absolute;
      top: 25px;
      left: 25px;
    }
  }
  .proposta__footer {
    margin-top: -47px;
  }

  .jns-button {
    text-transform: none;
    margin: 6px 12px;
  }
  .fluid-button {
    width: auto;
    padding-left: 30px;
    padding-right: 40px;
    transition: none;
    height: 50px;
    &.active {
      padding-right: 6px;
    }
  }
  .questionamento-dialog-button {
    width: 200px;
  }
  .jns-textarea {
    background: #eee;
  }
  .msg-erro,
  .msg-erro i {
    color: red !important;
    /*font-size: 12px;*/
    margin-right: 5px;
  }
}
.back-button {
  position: relative;
  padding-left: 30px;
  svg {
    position: absolute;
    margin-left: -30px;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    margin-top: -6px;
    margin-left: 6px;
    text-decoration: none;
    display: inline-block;
  }
}

.container {
  padding-bottom: 1vh;
}
.v-list__tile__title {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Apolices/Detalhar.vue